function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { variants } from "./types";
import { StyledPrimaryImage, StyledSecondaryImage } from "./styles";
import Wrapper from "./Wrapper";
var TokenPairImage = function(_param) {
    var primarySrc = _param.primarySrc, secondarySrc = _param.secondarySrc, width = _param.width, height = _param.height, _variant = _param.variant, variant = _variant === void 0 ? variants.DEFAULT : _variant, _primaryImageProps = _param.primaryImageProps, primaryImageProps = _primaryImageProps === void 0 ? {} : _primaryImageProps, _secondaryImageProps = _param.secondaryImageProps, secondaryImageProps = _secondaryImageProps === void 0 ? {} : _secondaryImageProps, props = _objectWithoutProperties(_param, [
        "primarySrc",
        "secondarySrc",
        "width",
        "height",
        "variant",
        "primaryImageProps",
        "secondaryImageProps"
    ]);
    var secondaryImageSize = Math.floor(width / 2);
    return /*#__PURE__*/ _jsxs(Wrapper, _objectSpread({
        position: "relative",
        width: width,
        height: height
    }, props, {
        children: [
            /*#__PURE__*/ _jsx(StyledPrimaryImage, _objectSpread({
                variant: variant,
                src: primarySrc,
                width: width,
                height: height
            }, primaryImageProps)),
            /*#__PURE__*/ _jsx(StyledSecondaryImage, _objectSpread({
                variant: variant,
                src: secondarySrc,
                width: secondaryImageSize,
                height: secondaryImageSize,
                style: {
                    position: "absolute"
                }
            }, secondaryImageProps))
        ]
    }));
};
export default TokenPairImage;
